import { useAppDispatch } from '@casops/store/hooks';
import { setView } from '@casops/store/slices/mapSlice';
import { useCallback } from 'react';
import { useMap, useMapEvent } from 'react-leaflet';

export const PersistedLocation = (): null => {
  const map = useMap();

  const dispatch = useAppDispatch();

  const update = useCallback(() => {
    const centre = map.getCenter().wrap();

    dispatch(
      setView({
        centreLat: centre.lat,
        centreLon: centre.lng,
        zoom: map.getZoom(),
      }),
    );
  }, [dispatch, map]);

  useMapEvent('zoomend', () => update());
  useMapEvent('moveend', () => update());

  return null;
};

export default PersistedLocation;
